var _path, _g, _g2, _g3, _g4, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeedarLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 191,
    height: 208,
    viewBox: "0 0 191 208",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M169.985 170.362H20.9415C13.395 170.362 6.60318 166.4 2.82993 159.986C-0.943311 153.571 -0.943311 145.647 2.82993 139.233L77.7288 10.3764C81.3134 3.96191 88.1052 0 95.6517 0C103.198 0 109.99 3.96191 113.575 10.3764L188.096 139.044C191.869 145.459 191.869 153.382 188.096 159.797C184.323 166.4 177.531 170.362 169.985 170.362ZM95.6517 2.64127C89.0485 2.64127 83.2 6.03719 79.8041 11.8857L5.28254 140.365C1.88662 146.025 1.88662 152.816 5.28254 158.476C8.4898 164.136 14.527 167.721 21.1302 167.721H170.173C176.776 167.721 182.625 164.325 186.021 158.476C189.228 152.816 189.228 146.025 186.021 140.365L111.311 11.5084C108.103 5.84853 102.255 2.64127 95.6517 2.64127Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M96.029 207.528C88.6712 207.528 82.068 203.755 78.2948 197.341L4.71653 70.3711C0.943286 63.9566 0.943286 56.2214 4.71653 49.8069C8.48977 43.3924 15.0929 39.6191 22.4508 39.6191H169.607C176.965 39.6191 183.568 43.3924 187.341 49.8069C191.115 56.2214 190.926 63.9566 187.341 70.3711L113.763 197.341C110.179 203.755 103.575 207.528 96.029 207.528ZM22.6394 41.8831C16.2249 41.8831 10.1877 45.279 6.98047 50.9389C3.77322 56.5987 3.77322 63.3906 6.98047 69.0504L80.5587 196.02C83.766 201.68 89.6145 205.076 96.2177 205.076C102.632 205.076 108.481 201.68 111.877 196.02L185.455 69.0504C188.662 63.3906 188.662 56.5987 185.455 50.9389C182.248 45.279 176.399 41.8831 169.796 41.8831H22.6394Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.64
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M134.516 179.795H55.0893C36.2231 179.795 19.6208 170.173 10.1877 153.948C1.13196 138.289 1.32062 119.423 10.5651 103.764L51.8821 33.7706C60.9379 18.6776 76.9741 9.62183 94.7084 9.62183C112.443 9.62183 128.479 18.6776 137.535 33.7706L178.852 103.764C188.096 119.423 188.285 138.289 179.229 153.948C169.985 170.173 153.382 179.795 134.516 179.795ZM94.7084 12.0744C77.7288 12.0744 62.4472 20.7529 53.9574 35.0912L12.6403 105.085C3.96189 119.801 3.77323 137.723 12.4517 152.816C21.1301 168.098 37.1664 177.342 55.0893 177.342H134.516C152.439 177.342 168.287 168.098 177.154 152.816C185.644 137.912 185.455 119.989 176.776 105.085L135.459 35.0912C126.97 20.7529 111.688 12.0744 94.7084 12.0744Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.21
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M94.7084 199.604C77.3515 199.604 61.6926 190.926 53.0141 176.022L12.6404 108.103C3.58462 92.8216 3.39596 74.5214 12.2631 59.2398C21.1302 43.3922 37.5438 34.1477 55.844 34.1477H133.196C151.496 34.1477 167.909 43.5808 176.776 59.4284C185.455 74.7101 185.455 93.199 176.399 108.292L136.403 176.21C127.536 190.737 111.877 199.604 94.7084 199.604ZM55.0894 174.701C63.3905 188.662 78.1062 197.152 94.7084 197.152C111.122 197.152 126.026 188.851 134.327 174.701L174.513 106.594C183.002 92.2557 183.191 74.7101 174.89 60.1831C166.4 45.2788 150.93 36.4116 133.384 36.4116H56.0327C38.6758 36.4116 23.0168 45.2788 14.527 60.1831C6.22589 74.7101 6.22589 92.067 14.9043 106.594L55.0894 174.701Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M126.026 191.115H64.5225C53.7687 191.115 43.7696 185.266 38.4871 175.833L7.35782 121.121C2.26395 111.876 2.26395 100.557 7.35782 91.501L38.4871 36.6003C43.9583 27.3559 53.7687 21.5073 64.7111 21.5073H126.215C136.969 21.5073 146.968 27.3559 152.25 36.789L183.191 91.6896C188.285 100.934 188.285 112.254 183.191 121.31L152.062 176.022C146.779 185.266 136.78 191.115 126.026 191.115ZM64.5225 23.9599C54.712 23.9599 45.4676 29.2425 40.751 37.9209L9.43311 92.6329C4.71655 100.934 4.71655 111.311 9.43311 119.8L40.5624 174.701C45.4676 183.191 54.712 188.662 64.5225 188.662H126.026C135.837 188.662 145.081 183.379 149.798 174.701L180.927 119.8C185.644 111.499 185.644 101.123 180.927 92.6329L149.986 37.7323C145.081 29.0538 136.025 23.7713 126.215 23.7713L64.5225 23.9599Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2372 126.781V140.176H58.4853L50.3728 126.592V76.4082H63.9565V126.592H89.0485L89.2372 126.781Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M140.742 76.4082V126.404L132.629 140.176H128.668H97.161L89.2372 126.781V126.592H89.0485V76.4082H102.821V126.592H127.158V76.4082H140.742Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_8530_40699",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(96.4561 86.0671) rotate(-0.235077) scale(215.969 192.709)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DADADA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_8530_40699",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(96.9728 124.447) rotate(-0.235031) scale(212.902 189.934)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DADADA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_8530_40699",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(95.6571 95.5936) rotate(-0.245803) scale(206.316 192.495)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DADADA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_8530_40699",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(95.4072 117.737) rotate(-0.245564) scale(200.793 187.16)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DADADA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_8530_40699",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(96.2287 107.193) rotate(-0.243541) scale(207.54 191.855)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DADADA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_8530_40699",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(70.0071 108.624) rotate(-0.432261) scale(43.963 72.1309)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DADADA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_8530_40699",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(115.164 108.624) rotate(-0.324987) scale(58.4743 72.1318)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DADADA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeedarLogo);
export default __webpack_public_path__ + "static/media/weedar-logo.35754dd0b25cd847bc78d1bb9c5b6a61.svg";
export { ForwardRef as ReactComponent };